import React from 'react';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import CrearReporteView from './CrearReporteView';
import CrearReporteMovilView from './CrearReporteMovilView';

/**
 * Vista automática que detecta el dispositivo y muestra
 * la versión apropiada del formulario de creación de reportes
 */
const CrearReporteAutoView: React.FC = () => {
  const { isMobile, isTablet } = useDeviceDetection();

  // Considerar tablets como móvil
  const esMobileOTablet = isMobile || isTablet;

  // console.log(`📱 Dispositivo detectado: ${esMobileOTablet ? 'Móvil/Tablet' : 'Desktop'}`);

  // Renderizar versión móvil o desktop según el dispositivo
  if (esMobileOTablet) {
    return <CrearReporteMovilView />;
  }

  return <CrearReporteView />;
};

export default CrearReporteAutoView;
